import React, { useRef, useState, useEffect } from 'react';
import Menu from './Menu';
import { LayoutOrientations } from '../../globals';
import DomUtils from '../../classes/utilities/DomUtils';
import { MenuClosureReasons, MenuItemHoverTime } from '../../interfaces/Menus';
import { KeyCodes } from '../../interfaces/Input';

export default function MenuBar(props)
{
	const [openedMenu, setOpenedMenu] = useState(-1);
	const [hoveredChild, setHoveredChild] = useState(-1);

	const selfRef = useRef<HTMLDivElement>(null);
	const itemHoverTimer = useRef<any>(null);

	const orientation = props.orientation ? props.orientation : LayoutOrientations.Horizontal;

	useEffect(() =>
	{
	}, [hoveredChild])

	function menuWantsToOpen(menuId: number)
	{
		setOpenedMenu(menuId);

		window.addEventListener('mousedown', closeAll);
	}

	function menuClosed(reason: MenuClosureReasons)
	{
		setOpenedMenu(-1);
		setHoveredChild(-1);
	}

	function closeAll(e)
	{
		if(!selfRef.current) return;

		// check first if e.target is within a menu item - if so, do nothing; the menu should close itself according to props
		if (!DomUtils.isDomElementDescendantOfRoot(e.target, selfRef.current))
		{
			setOpenedMenu(-1);
			window.removeEventListener('mousedown', closeAll);
		}
	}

	return (
		<div
			ref={selfRef}
			className={[
				"menuBar",
				orientation,
				(props.className ? props.className : ""),
			].join(' ')}
			onKeyDown={(e) =>
			{
				if (e.keyCode === KeyCodes.ESCAPE)
				{
					closeAll(e);
				}
			}}
		>
			{
				React.Children.map(props.children, (child, idx) =>
				{
					if (React.isValidElement(child))
						return (
							<div className="menuBarSubItem"
								data-status={idx === openedMenu && hoveredChild === idx ? "opened" : "closed"}
								onMouseEnter={() =>
								{
									itemHoverTimer.current = setTimeout(() =>
									{
										setHoveredChild(idx);
									}, MenuItemHoverTime);
								}}
								onMouseLeave={() =>
								{
									clearTimeout(itemHoverTimer.current);
								}}
							>
								{
									child.type !== Menu ?
										child :
										React.cloneElement(child as any, {
											id: idx,
											orientation: orientation === LayoutOrientations.Horizontal ? LayoutOrientations.Vertical : LayoutOrientations.Horizontal,
											menuOpenCallback: menuWantsToOpen,
											shouldBeOpen: idx === openedMenu && hoveredChild === idx,
											menuClosedCallback: menuClosed,
											hoverMenu: openedMenu >= 0,
										})
								}
							</div>
						);
				})
			}
		</div>
	)
}